import { render, staticRenderFns } from "./LaCooperativeCustomers.vue?vue&type=template&id=9f236c26&scoped=true&"
import script from "./LaCooperativeCustomers.vue?vue&type=script&lang=js&"
export * from "./LaCooperativeCustomers.vue?vue&type=script&lang=js&"
import style0 from "./LaCooperativeCustomers.vue?vue&type=style&index=0&id=9f236c26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f236c26",
  null
  
)

export default component.exports